import React from "react"
import Img from "gatsby-image"
import { Link, graphql, useStaticQuery } from "gatsby"
import headerStyles from "./header.module.css"
import { rhythm, scale } from "../utils/typography"

// #3 Why Dev Nano should be in the header.
// Expect it in main container layout props  then

export default ({ title, whyDevNano, author }) => {
  const data = useStaticQuery(
    graphql`
      query {
        file(relativePath: { eq: "nano.jpg" }) {
          childImageSharp {
            # Specify the image processing specifications right in the query.
            # Makes it trivial to update as your page's design changes.
            fixed(width: 125, height: 125) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    `
  )
  return (
    <div>
      <Link to={`/`}>
        <h1 style={{ marginBottom: rhythm(0), padding: 0 }}>{title}</h1>
      </Link>
      <p style={{ ...scale(-1), marginTop: rhythm(0) }}>
        {/* #3: map is not the best here as we only need the first node. */
        whyDevNano.edges.map(({ node }) => (
          <div key={node.id}>
            <Link to={node.fields.slug}>{node.frontmatter.title}</Link>
          </div>
        ))}
      </p>
      <Link className={headerStyles.profilePictureLink} to={`/`}>
        <Img
          className={headerStyles.profilePicture}
          fixed={data.file.childImageSharp.fixed}
        />
      </Link>
      {/* #3: map is not the best here as we only need the first node. */
      author.edges.map(({ node }) => (
        <div key={node.id}>
          <Link to={`/`}>
            <h4>{node.frontmatter.title}</h4>
          </Link>
          <p
            style={{ ...scale(-1 / 5) }}
            dangerouslySetInnerHTML={{ __html: node.html }}
          />
        </div>
      ))}{" "}
    </div>
  )
}
